import React from "react";
import ConfidenceIndicator from "@ui/Indicator/Confidence";
import BookmarkLine from "@ui/IconV2/react/BookmarkLine";
import { StarFill } from "@ui/IconV2/react";
import { colors, spacings } from "@ui/Theme";
import { css } from "@linaria/core";

export const NO_CONFIDENCE_INDICATOR = -1;

type FailureValue = {
  isManual: boolean;
  confidenceIndicator: number;
  isPromoted: boolean | null;
};

const FailureIcon = ({ failure }: { failure: FailureValue }) => (
  <div className={iconWrapper}>
    {failure.isPromoted && <StarFill className={starIcon} />}
    {failure.isManual ? (
      <BookmarkLine size="s" />
    ) : (
      failure.confidenceIndicator !== NO_CONFIDENCE_INDICATOR && (
        <ConfidenceIndicator
          className={confidenceIndicator}
          value={failure.confidenceIndicator}
          size="small"
        />
      )
    )}
  </div>
);

export default React.memo(FailureIcon);

//#region CSS
const confidenceIndicator = css`
  margin-left: 5px;
`;

const iconWrapper = css`
  display: flex;
  align-items: center;
  gap: ${spacings.s};
  flex-shrink: 0;
  position: relative;
  padding-left: 10px;
`;

const starIcon = css`
  color: ${colors.phosphorus400};
  width: 14px;
  height: 14px;
  position: absolute;
  top: -8px;
  left: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
//#endregion
